import { nsUser } from '@/app/i18n/namespaces';

const USER_PROFILES = {
    PROFILE_ADMIN: { name: 'PROFILE_ADMIN', entity: 'profile.PROFILE_ADMIN', namespace: nsUser },
    PROFILE_READ_ONLY: { name: 'PROFILE_READ_ONLY', entity: 'profile.PROFILE_READ_ONLY', namespace: nsUser },
    PROFILE_SIM_AND_TERMINAL_MANAGER: { name: 'PROFILE_SIM_AND_TERMINAL_MANAGER', entity: 'profile.PROFILE_SIM_AND_TERMINAL_MANAGER', namespace: nsUser },
    PROFILE_HOTLINE: { name: 'PROFILE_HOTLINE', entity: 'profile.PROFILE_HOTLINE', namespace: nsUser }
};

export default USER_PROFILES;